#
# The segment editor
#
# @todo Refactor into class methods (MY EYES! :scream:)
#
class @SegmentationBuilder

  @setup: ->

    criteriaContainer = $(".criterias")
    mailingListId = criteriaContainer.data("mailing-list-id")
    movingCriteria = null
    allowSubmit = false

    return unless mailingListId && criteriaContainer.length > 0

    # If we've got a segment id, pass it along to the blank criteria page to
    # help it render without this segment in the nested segment list.
    blankCriteriaPath = (type) ->
      Routes.blank_criteria_segmentation_criterias_path
        mailing_list_id: mailingListId
        type: type
        segmentation_criteria_id: $("#segmentation_criteria_id").val()

    # The markup renders the attributes as "name", but we want to change it to
    # be "data-name" to prevent those fields from actually being submitted.
    changeNameAttributes = (container) ->
      container.find("[name]").each ->
        $e = $(@)
        $e.attr("data-name", $e.attr("name"))
        # This isn't ideal, but needed. The testing API Capybara uses the
        # `name` attribute heavily. But in development and testing, we don't
        # want these elements to post to the server.
        if window.RailsEnv != "test"
          $e.removeAttr("name")

    initializePage = ->
      UI.setupDatepickers criteriaContainer
      UI.hideElementsInHiddenTabs criteriaContainer

      changeNameAttributes criteriaContainer

      $("select", criteriaContainer).each ->
        $select = $(@)

        # Set proper width and wrap into select2
        width =
          if $select.data("width") then parseInt($select.data("width"), 10)
          else if $select.is(".criteria-type") then 325
          else if $select.is(".operator") then 225
          else $select.show().width() + 100
        UI.setupSelects $select.css("width", width)
        $select.addClass 'disable-select2' # to avoid double initialization
        adjustElementVisibilityForOperator.apply $select if $select.attr('data-name') == "operator"

        if $select.is('[data-reload]')
          $select.on 'change', ->
            renderCurrent JSON.stringify(serializeCriteria(criteriaContainer.children(".criteria.first")))

    insertPlaceholder = (criteria, mouseEvent) ->
      # Set up the insertion by finding the sub-criterias and the placeholder object.
      subCriterias = criteria.children(".criteria")
      for subCriteriaElement in subCriterias.toArray()
        # Calculate the edges of the sub-criteria.
        subCriteria  = $(subCriteriaElement)
        offsetOfSub  = subCriteria.offset()
        middleOfSub  = offsetOfSub.top + subCriteria.outerHeight()/2
        leftOfSub    = offsetOfSub.left
        rightOfSub   = offsetOfSub.left + subCriteria.outerWidth()
        topOfSub     = offsetOfSub.top
        bottomOfSub  = offsetOfSub.top + subCriteria.outerHeight()
        subIsGroup   = subCriteria.is(".criteria[data-type=all], .criteria[data-type=any]")
        mouseInX     = leftOfSub < mouseEvent.pageX < rightOfSub
        mouseInY     = topOfSub < mouseEvent.pageY < bottomOfSub
        subNotMoving = movingCriteria[0] != subCriteriaElement
        # Allow the user to drag a criteria into a sub-criteria.
        if subIsGroup && mouseInX && mouseInY && subNotMoving
          insertPlaceholder subCriteria, mouseEvent
          return
        # Move the criteria just above this sub-criteria if we haven't crossed the half-way point.
        else if mouseEvent.pageY < middleOfSub
          if subCriteriaElement != movingCriteria[0]
            movingCriteria.insertBefore(subCriteria)
          return
      # If there are no sub-criteria, append it to the parent criteria.
      if subCriterias.length == 0
        movingCriteria.appendTo(criteria)
      # Otherwise, insert it after the last sub-criteria.
      else
        movingCriteria.insertAfter(subCriterias.last()) if subCriterias.last()[0] != movingCriteria[0]

    disableSubmit = ->
      $("img.serialize-segmentation-criteria-loading").show()
      $("button.serialize-segmentation-criteria.button").hide()
      allowSubmit = false

    enableSubmit = ->
      $("img.serialize-segmentation-criteria-loading").hide()
      $("button.serialize-segmentation-criteria.button").show()
      allowSubmit = true

    adjustElementVisibilityForOperator = ->
      selectBox = $(this)
      selectOptions = selectBox.find("option").get()
      operators = _.map selectOptions, (opt) -> $(opt).attr("value")
      criteria = selectBox.closest(".criteria").find(".criteria-content")
      segments = criteria.find('[data-show-for-operators]')

      segments.hide()
      segments.each ->
        for showFor in $(this).data('show-for-operators').split(',')
          $(this).show() if showFor.trim() == selectBox.val()

    adjustElementVisibilityForAllOperators = ->
      criteriaContainer.find("select[data-name=operator]").each adjustElementVisibilityForOperator

    serializeCriteria = (criteria) ->
      hash = {}
      for domInput in criteria.children(".criteria-content").find("input,textarea,select")
        input = $(domInput)
        name = input.attr("data-name")
        value = input.val()
        continue unless name
        continue if input.is(":checkbox") && !input.is(":checked")
        if arrayMatch = name.match(/(.*)\[\]/)
          hash[arrayMatch[1]] ||= []
          hash[arrayMatch[1]].push value
        else
          hash[name] = value
      if hash.type == "all" || hash.type == "any"
        hash.clauses = (serializeCriteria($(c)) for c in criteria.children(".criteria"))
      hash

    renderCurrent = (json) ->
      json ||= $("#segmentation_criteria_criteria_json,#campaign_segmentation_criteria_attributes_criteria_json,.criteria-json").val()
      if json? && json != ""
        disableSubmit()
        applyToActive = $("#apply_only_to_active_subscribers").val()
        url = Routes.render_criteria_segmentation_criterias_path
          mailing_list_id: mailingListId
          apply_only_to_active_subscribers: applyToActive
          segmentation_criteria_id: $("#segmentation_criteria_id").val()
        $.post url, { segmentation_criteria_json: json }, (html) ->
          criteriaContainer.html(html)
          initializePage()
          enableSubmit()

    criteriaContainer.on "change", "select.criteria-type", ->
      select = $(this)
      criteria = select.closest(".criteria")
      oldType = criteria.attr("data-type")
      newType = $(this).val()
      if (oldType in [ "all", "any" ]) && (newType in [ "all", "any" ])
        # Don't default the content when we switch between all and any.
      else
        $.get blankCriteriaPath(newType), (html) ->
          criteria.html("")
          criteria.append $(html).children() # Remove the "criteria" frame around the clause since we are replacing the current one.
          initializePage()
      criteria.attr("data-type", newType)
      return true

    criteriaContainer.on "click", ".add-criteria", ->
      criteria = $(this).closest(".criteria")
      $.get blankCriteriaPath("subscriber_status"), (html) ->
        subCriteria = $(html)
        subCriteria.hide()
        criteria.append subCriteria
        subCriteria.show() # we have to trigger DOM calculations to give select real width
        initializePage()
        subCriteria.hide().slideDown 200
      return false

    criteriaContainer.on "click", ".remove-criteria", ->
      criteria = $(this).closest(".criteria")
      slideDuration = Math.log(2*criteria.outerHeight()) * 25
      criteria.slideUp slideDuration, -> criteria.remove()
      return false

    criteriaContainer.on "mousedown", ".reorder-criteria", (e) ->
      movingCriteria = $(this).closest(".criteria")
      movingCriteria.addClass("moving")
      return false

    criteriaContainer.on "click", ".reorder-criteria", (e) ->
      Dialogs.presentAlertModal t("notices.drag_criteria_to_reorder")
      return false

    criteriaContainer.on "mousemove", (e) ->
      return true if movingCriteria == null
      insertPlaceholder criteriaContainer.children(".criteria"), e
      return false

    criteriaContainer.on "change", "select[data-name=operator]", adjustElementVisibilityForOperator

    $(document).on "mouseup", ->
      if movingCriteria != null
        movingCriteria.removeClass("moving")
        movingCriteria = null
      return true

    criteriaContainer.closest("form").on "submit", ->
      if !allowSubmit
        return false
      # Serialize the segment.
      serialized = serializeCriteria(criteriaContainer.children(".criteria.first"))
      json = JSON.stringify(serialized)
      $("#segmentation_criteria_criteria_json,#campaign_segmentation_criteria_attributes_criteria_json,.criteria-json").val(json)
      return true

    $(".save-criteria-controls input[type=checkbox]").on "change", ->
      nameSection = $("#segmentation_criteria_name").closest(".control-group")
      nameSection.slideToggle 100, -> nameSection.find("input").focus()
      return true

    renderCurrent()
    initializePage()
